$(document).foundation();

$(document).ready(function () {
    // utils
    initVerticalCenter();
    initAnimateInView();
    inlineSVGs([
    	'.footer__social img',
    	'.room__gallery img'
    	]);

    // global
    initSliders();
    initHeadings();
    initForms();
    initOffCanvas();
    initBooking();
    initDropdownNav();
    formCheckboxValid();
    initTableBookings();

    // template specific
    initAccordions();
    initForms();
    initMaps();
    initGalleries();
    initAttractionsMap();
    initMasonry();
    initVouchers();
});

// function initTableBookings() {
// 	$('a[href*="#book-a-table"]').on('click', function (e)  {
// 		$('#book-a-table').foundation('open');
// 		e.preventDefault();
// 	});
// }



function initDropdownNav() {
	/*$('.header__sub-nav').each( function () {
		$(this).css('left', ($(this).parent().outerWidth() - $(this).outerWidth()) / 2 + 'px' );
	});*/

	$('.header__primary-nav > ul > li').on('mouseenter', function (e) {
		if ($('html').attr('data-whatintent') === 'mouse') {
			$(this).find('.header__sub-nav').addClass('open');
		}
	});

	$('.header__primary-nav > ul > li').on('mouseleave', function (e) {
		if ($('html').attr('data-whatintent') === 'mouse') {
			$(this).find('.header__sub-nav').removeClass('open');
		}
	});

	$('.header__primary-nav > ul > li').on('touchstart', function (e) {
		var $dropdown = $(this).find('.header__sub-nav');
		if ( $dropdown.hasClass('open') ) {
			return; // menu has been pressed second time so allow to navigate there
		} else {
			$('.header__sub-nav.open').removeClass('open');
			$dropdown.addClass('open');
			e.preventDefault();
		}
	});
}

function formCheckboxValid() {
	$('.form-check').validate({
		rules: {
			list: {
				required: true
			}
		}
	});
}



function initVerticalCenter() {
	$('.vertical-center').each(function () {
		$(this).wrapInner('<div class="vertical-center-table"><div class="vertical-center-row"><div class="vertical-center-cell"></div></div></div>');
	});
}



// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(inputValue) {
	var selectorString = '';
	if (typeof inputValue === "object") {
		selectorString = inputValue.join(',');
	} else {
		selectorString = inputValue;
	}

	$(selectorString).each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		if (imgURL.indexOf('.svg') > -1) {
			$.get(imgURL, function (data) {
	            // Get the SVG tag, ignore the rest
	            var $svg = $(data).find('svg');

	            // Add replaced image's ID to the new SVG
	            if (typeof imgID !== 'undefined') {
	            	$svg = $svg.attr('id', imgID);
	            }
	            // Add replaced image's classes to the new SVG
	            if (typeof imgClass !== 'undefined') {
	            	$svg = $svg.attr('class', imgClass + ' replaced-svg');
	            }

	            // Remove any invalid XML tags as per http://validator.w3.org
	            $svg = $svg.removeAttr('xmlns:a');

	            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
	            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
	            	$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
	            }

	            // Replace image with new SVG
	            $img.replaceWith($svg);
	        }, 'xml');
		}
	});
}



function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}







/**
 * Scales any element to simulate the CSS background-size: cover property.
 * @param {DOMelement} element The element to scale
 * @param {bool} [scaleToParent] Scale the element to fill the parent instead
 *                               of the whole browser window.
 */
 function coverViewport(element, scaleToParent) {
 	if (typeof scaleToParent === 'undefined') { scaleToParent = false; }

 	var viewportWidth, viewportHeight;
 	if (scaleToParent) {
 		viewportWidth = $(element).parent().innerWidth();
 		viewportHeight = $(element).parent().innerHeight();
 	} else {
 		viewportWidth = $(window).innerWidth();
 		viewportHeight = $(window).innerHeight();
 	}

 	var $element = $(element);

 	var elementWidth = $element.attr('width');
 	var elementHeight = $element.attr('height');

    // Aspect ratio = height / width
    var viewportRatio = viewportHeight / viewportWidth;
    var videoRatio = elementHeight / elementWidth;

    //console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


    var newWidth = (elementWidth / elementHeight) * viewportHeight
    var newHeight = (elementHeight / elementWidth) * viewportWidth;
    var newTop = 0;

    if (viewportRatio > videoRatio) {
        // set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
        //console.log('crop left and right');
        $element.css('height', viewportHeight);
        $element.css('width', newWidth);
        $element.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
        $element.css('top', '0');
    } else if (viewportRatio < videoRatio) {
        // set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
        //console.log('crop top and bottom');
        $element.css('width', viewportWidth);
        $element.css('height', newHeight);
        $element.css('left', '0');
        $element.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
    } else {
        // set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
        //console.log('no crop');
        $element.css('height', viewportHeight);
        $element.css('width', viewportWidth);
        $element.css('left', '0');
        $element.css('top', '0');
    }
}






function initSliders() {

	$('.slider__inner').reformSlider({
		speed: 4000,
		animationSpeed: 1000,
		arrows: false,
		pagination: false,
		paginationArrows: false
	});

	$('.offers-carousel__inner').slick({
		centerMode: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerPadding: '0px',
		arrows: true,
		infinite: true,
		responsive: [
		{
			breakpoint: 1140,
			settings: {
				centerMode: true,
				centerPadding: '0px',
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
			}
		}
		]
	});

	$('.home-content__inner').each(function () {
		$(this).slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
		})
	})

	$('.listing__inner').each(function () {
		$(this).slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
		})
	})

	$('.listing__event-carousel-inner').each(function () {
		$(this).slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
		})
	})

	$('.menus__carousel-inner').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
	});


	$('.menus__carousel-nav ul li a').on('click', function() {
		var slider = $('.menus__carousel-inner');
		var dataValue = $(this).data('id');
		slider.slick('slickGoTo', parseInt(dataValue));
	});

}



function initAnimateInView() {
	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();
}

function animateElementsInView() {
	$('[data-animate-in-view]').each(function () {
		//console.log($(this));
		if ( isElementInViewport($(this)) ) {
			$(this).addClass( $(this).data('animate-in-view') );
		}
	});
}

// https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
function isElementInViewport (el) {
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
    	el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
    	rect.top <=  $(window).scrollTop() + window.innerHeight
    	);
}




function initHeadings() {
	// Find '&' characters in headings and wrap them with a span to make them styleable
	var selectors = [
	".home-offers__heading h2:contains('&')"
	];

	$(selectors.join(',')).html(function(_, html) {
		return html.replace(/(&amp;)/g, '<span>$1</span>');
	});
}




function initForms() {
	$('.validate-this').validate();

	$('.custom-select select').selectric();
}




function initOffCanvas() {
	// Generate the dynamic sub nav
	var count = 0;
	$('.burger__primary > ul > li').each(function () {
		if ( $(this).find('ul').length > 0 ) {
			var $landingLink = $(this).find('a').first();

			$('.burger__inner').append( '<nav id="burger__sub-' + count + '" class="burger__sub" style="padding-top: ' + $(this).offset().top + 'px"><button class="burger__sub-close" type="button">Close sub menu</button><ul><li><a href="' + $landingLink.attr('href') + '">' + $landingLink.text() + ' Overview</a></li>' + $(this).find('ul').html() + '</ul></nav>' );

			$landingLink.data('open-sub', count);

			count++;
		}
	});

	// Open the dynamic sub nav only for items which have it
	$('.burger__primary > ul > li > a').on('click', function () {
		if ( typeof $(this).data('open-sub') !== 'undefined' ) {
			var subId = $(this).data('open-sub');

			$('.burger__sub--is-open').removeClass('burger__sub--is-open');

			$('#burger__sub-' + subId).addClass('burger__sub--is-open');

			return false;
		}
	});

	$('.burger__sub-close').on('click', function () {
		$(this).parent().removeClass('burger__sub--is-open');
	});

	$('#offCanvas').on('closed.zf.offcanvas', function () {
		$('.burger__sub--is-open').removeClass('burger__sub--is-open');
	});
}



function initAccordions() {
	$('.accordion').accordiom({
		showFirstItem: false
	});

	$('.accordionButton').each( function() {
		if ( $(this).next('.accordionContent').children().length <= 0 ) {
			$(this).css("background", "none");
		}
	})

  $('.accordionDetail').accordiom();
}





var customMapStyle = [{"featureType":"all","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"saturation":"11"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"color":"#ffffff"},{"visibility":"on"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#363636"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"off"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#363636"},{"visibility":"on"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#e9e9e9"}]},{"featureType":"administrative.neighborhood","elementType":"geometry","stylers":[{"saturation":"-43"},{"lightness":"-19"},{"gamma":"1.87"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text","stylers":[{"weight":"0.50"},{"gamma":"1.88"},{"lightness":"-12"},{"saturation":"-100"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#e9e9e9"},{"visibility":"simplified"}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#b6c8c6"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"visibility":"off"},{"color":"#d9c694"},{"lightness":"0"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"visibility":"off"},{"color":"#b6c8c6"},{"lightness":"0"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45},{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"weight":"1.00"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#e9e9e9"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#ffffff"},{"weight":"5.00"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"visibility":"on"},{"weight":"3"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ebebeb"},{"visibility":"on"},{"weight":"1"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#363636"},{"visibility":"on"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#aaaaaa"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry","stylers":[{"saturation":"9"},{"color":"#217267"}]}]

function initMaps() {
	$('[data-map]').each(function () {
		var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;

		if (typeof $(this).data('map-center-coords') != 'undefined') {
			centerLat = parseFloat( $(this).data('map-center-coords').split(',')[0] );
			centerLng = parseFloat( $(this).data('map-center-coords').split(',')[1] );
		} else {
			centerLat = 0;
			centerLng = 0;
		}

		zoom = $(this).data('map-zoom') || 8;

		if (typeof customMapStyle !== 'undefined') {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				styles: customMapStyle
			});
		} else {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false
			});
		}


		if (typeof $(this).data('map-marker-coords') != 'undefined') {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		}

		$(this).siblings('[data-map-marker]').each(function () {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}
		});

		if (typeof $(this).data('map-directions') != 'undefined') {
			var directionsService  = new google.maps.DirectionsService();
			var directionsRenderer = new google.maps.DirectionsRenderer();
			directionsRenderer.setMap(map);
			directionsRenderer.setPanel($('#map-directions-data').get(0));

			var directionsTo = $(this).data('map-directions-destination');

			$('#frmPostcode').on('submit', function() {
				var directionsFrom = jQuery.trim(jQuery('#tbPostcode').val());
				var directionsRequest = {
					origin: directionsFrom,
					destination: directionsTo,
					travelMode: google.maps.TravelMode.DRIVING,
					unitSystem: google.maps.UnitSystem.IMPERIAL
				};

				directionsService.route(directionsRequest, function(result, status){
					if (status == google.maps.DirectionsStatus.OK) {
						marker.setMap(null);
						directionsRenderer.setDirections(result);
					} else {
						alert('Location "' + directionsFrom + '" not found.');
					}
				});

				return false;
			});
		}
	});




	$('.find-us__map-controls-zoom').on('click', function () {
		$('#find-us__map-popup').foundation('open');
	});

	$('.find-us__map-controls-print').on('click', function () {
		window.print();
	});
}



function initAttractionsMap() {
	$('[data-attractions-map]').each(function () {
		var map, centerLat, centerLng, zoom, marker, markerLat, markerLng;

		if (typeof $(this).data('map-center-coords') != 'undefined') {
			centerLat = parseFloat( $(this).data('map-center-coords').split(',')[0] );
			centerLng = parseFloat( $(this).data('map-center-coords').split(',')[1] );
		} else {
			centerLat = 0;
			centerLng = 0;
		}

		zoom = $(this).data('map-zoom') || 8;

		if (typeof customMapStyle !== 'undefined') {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				styles: customMapStyle
			});
		} else {
			map = new google.maps.Map($(this)[0], {
				center: {lat: centerLat, lng: centerLng},
				zoom: zoom,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false
			});
		}

		$(this).siblings('[data-map-marker]').each(function () {
			if (typeof $(this).data('map-marker-coords') != 'undefined') {
				markerLat = parseFloat( $(this).data('map-marker-coords').split(',')[0] );
				markerLng = parseFloat( $(this).data('map-marker-coords').split(',')[1] );
			} else {
				markerLat = 0;
				markerLng = 0;
			}

			marker = new google.maps.Marker({
				position: {lat: markerLat, lng: markerLng},
				map: map
			});

			if (typeof $(this).data('map-marker-url') != 'undefined') {
				marker.setIcon($(this).data('map-marker-url'));
			}

			var $panel = $('#' + $(this).data('map-popup'));

			marker.addListener('mouseover', function () {
				$panel.foundation('open');
			});

			marker.addListener('click', function () {
				$panel.foundation('open');
			});
		});
	});
}




function initGalleries() {
	$('[data-gallery]').on('click', function () {
		//var activeSlideIndex = $(this).data('slide-index') || $(this).next().find('.slick-active').index();

		var activeSlideIndex = $(this).index() || 0;

		$('.gallery-popup__inner')
		.empty()
		.load($(this).data('gallery'), function () {
			$('.gallery-popup .slider').slick({
				initialSlide: Math.max(activeSlideIndex -1, 0),
				arrows: true,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
			});
		});
		$('.gallery-popup').foundation('open');
	});
}




function initBooking() {
	$('#bookingOffCanvas').on('opened.zf.offcanvas', function () {
		$('.header__burger-menu-container').fadeOut();
	});

	$('#bookingOffCanvas').on('closed.zf.offcanvas', function () {
		$('.header__burger-menu-container').fadeIn();
	});

	$('.booking__selector select').on('change', function () {
		$('.booking__wrapper').hide();
		$('.booking__wrapper[data-booking-type="' + $(this).val() + '"]').show();
	});

	// general bookings
	var book = $('a[href="#book-now"]')
	book.on('click', function () {
		Booking.Open()
	})

	// room bookings
	var roomBtns = $("a[href^='#roomID:']")
	roomBtns.each(function () {
		$(this).on('click', function (e) {
			e.preventDefault()
			var id = $(this).attr('href').replace(/^#/, "").split(':')[1]
			Booking.Open({roomID:id})
		})
	})

	//offer bookings
	var offerBtns = $("a[href^='#offerID:']")
	offerBtns.each(function () {
		$(this).on('click', function (e) {
			e.preventDefault()
			var id = $(this).attr('href').replace(/^#/, "").split(':')[1]
			Booking.Open({offerID:id})
		})
	})



	// var nowTemp = new Date();
	// var now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);

	// var checkin = $('#check-in').fdatepicker({
	// 	format: 'dd/mm/yyyy',
	// 	leftArrow:'<<',
	// 	rightArrow:'>>',
	// 	onRender: function (date) {
	// 		return date.valueOf() < now.valueOf() ? 'disabled' : '';
	// 	}
	// }).on('changeDate', function (ev) {
	// 	if (ev.date.valueOf() > checkout.date.valueOf()) {
	// 		var newDate = new Date(ev.date)
	// 		newDate.setDate(newDate.getDate() + 1);
	// 		checkout.update(newDate);
	// 	}
	// 	checkin.hide();
	// 	$('#check-out')[0].focus();
	// }).data('datepicker');

	// var checkout = $('#check-out').fdatepicker({
	// 	format: 'dd/mm/yyyy',
	// 	leftArrow:'<<',
	// 	rightArrow:'>>',
	// 	onRender: function (date) {
	// 		return date.valueOf() <= checkin.date.valueOf() ? 'disabled' : '';
	// 	}
	// }).on('changeDate', function (ev) {
	// 	checkout.hide();
	// }).data('datepicker');


	// $('.booking__form').on('submit', function () {
	// 	var normalDate = $('#check-in').val();
	// 	if (normalDate == '') { // Preset to today if no date is picked...
	// 		var today = new Date();
	// 		normalDate = pad((today.getMonth() * 1 + 1), 2) + '/' + today.getDate() + '/' + today.getFullYear();
	// 		$('input[name="arrive"]').val(normalDate);
	// 	} else {
	// 		$('input[name="arrive"]').val(pad((checkin.date.getMonth() * 1 + 1), 2) + '/' + checkin.date.getDate() + '/' + checkin.date.getFullYear());
	// 	}

	// 	normalDate = $('#check-out').val();
	// 	if (normalDate == '') { // Preset to today if no date is picked...
	// 		var today = new Date();
	// 		normalDate = pad((today.getMonth() * 1 + 1), 2) + '/' + today.getDate() + '/' + today.getFullYear();
	// 		$('input[name="depart"]').val(normalDate);
	// 	} else {
	// 		$('input[name="depart"]').val(pad((checkout.date.getMonth() * 1 + 1), 2) + '/' + checkout.date.getDate() + '/' + checkout.date.getFullYear());
	// 	}

	// });

	// function pad(n, width, z) {
	// 	z = z || '0';
	// 	n = n + '';
	// 	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	// }

}




function initMasonry() {

	$('.gallery-masonry').imagesLoaded( function(){
		$('.grid').masonry({
  		// options
  		itemSelector: '.grid-item',
  		columnWidth: '.grid-sizer',
  		percentPosition: true,
  		fitWidth: false
  		});
  	});

}




function initVouchers() {
	$('.voucher-quantity select').selectric({
		disableOnMobile: false,
		nativeOnMobile: false,
		onChange: function () {
			var dropdown = $(this);
			var selectedPrice = dropdown.find('option:selected').data('price');

			dropdown
			.closest('form')
			.find('input[name="price"]')
			.val(selectedPrice);
		}
	});

	$('.gift-vouchers form').each(function () {
		$(this).validate();
	});

}

$(window).on('load', function() {
	centerLastOddOffer();
})

function centerLastOddOffer() {
	var offers = $('.offers');

	if ( offers.children().length % 2 === 1 ) {
		offers.children().last().css('margin', '0 auto');
	}
}


function initTableBookings() {
	$('a[href*="#book-a-table"]').on('click', function() {
		$('body').addClass('is-reveal-open')
		$('.book-a-table').css('display', 'block')
		// $('#rd-widget-frame').attr('src', 'https://7723fded-c4a4-4605-b717-6a890ecd2c71.resdiary.com/widget/Standard/TheSalthouseEaterie/5198?includeJquery=true');
	});

	$('.book-a-table .close-button').on('click', function() {
		$('.book-a-table').css('display', 'none')
		$('body').removeClass('is-reveal-open')
	})
}

$('.form__checkmark').on('click', function() {
	$(this).prev().click();
});

$('.form__checkbox-container label').on('click', function() {
	$(this).prev().prev().click();
});

